<mat-tab-group class="sales-tabs" mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab label="トラック">
    <app-sp-track-sales></app-sp-track-sales>
  </mat-tab>
  <mat-tab label="作品">
    <app-sp-project-sales></app-sp-project-sales>
  </mat-tab>
</mat-tab-group>
